import { render } from "./TableView.vue?vue&type=template&id=0a340a43"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/qc-getplaces-staging-gcs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__